import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ComputerIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.00156 11.1984V12.7984M5.60156 13.5984H10.4016M3.20156 11.1984H12.8016C13.6852 11.1984 14.4016 10.4821 14.4016 9.59844V3.99844C14.4016 3.11478 13.6852 2.39844 12.8016 2.39844H3.20156C2.31791 2.39844 1.60156 3.11478 1.60156 3.99844V9.59844C1.60156 10.4821 2.31791 11.1984 3.20156 11.1984Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

ComputerIcon.displayName = 'ComputerIcon';
